import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-300a00e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_2 = { class: "modalDialog-content modal-content" }
const _hoisted_3 = { class: "message-header" }
const _hoisted_4 = { class: "modalDialog-contentArea message-body" }

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalDialog',
  props: {
    active: { type: Boolean },
    title: null,
    severity: null,
    firstButtonText: null,
    firstButtonSeverity: null,
    secondButtonText: null,
    secondButtonSeverity: null,
    thirdButtonText: null,
    thirdButtonSeverity: null,
    allowClose: { type: Boolean }
  },
  emits: ['close', 'firstbuttonselected', 'secondbuttonselected', 'thirdbuttonselected'],
  setup(__props: any, { emit }) {

const props = __props as {
  active: boolean,
  title: string,
  severity?: string,
  firstButtonText?: string,
  firstButtonSeverity?: string,
  secondButtonText?: string,
  secondButtonSeverity?: string,
  thirdButtonText?: string,
  thirdButtonSeverity?: string,
  allowClose?: boolean
}





const onClose = () => {
  emit('close');
};

// If the combined length of the button text is long enough, we'll display them vertically instead of side-by-side
const displayVertically = computed(() => {
  let len = 0;
  if (props.firstButtonText) { len += props.firstButtonText.length; }
  if (props.secondButtonText) { len += props.secondButtonText.length; }
  if (props.thirdButtonText) { len += props.thirdButtonText.length; }
  return len > 40;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal", { 'is-active': __props.active }])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("article", {
        class: _normalizeClass(["message", `is-${__props.severity}`])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", null, _toDisplayString(__props.title), 1),
          (__props.allowClose)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "delete",
                "aria-label": "delete",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (onClose()))
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _createElementVNode("footer", {
          class: _normalizeClass(["modalDialog-buttonArea modal-card-foot", { 'modalDialog-buttonArea-vertical': _unref(displayVertically) }])
        }, [
          (__props.firstButtonText)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('firstbuttonselected'))),
                class: _normalizeClass(["button", `is-${__props.firstButtonSeverity}` + (_unref(displayVertically) ? ' button-vertical' : '')])
              }, _toDisplayString(__props.firstButtonText), 3))
            : _createCommentVNode("", true),
          (__props.secondButtonText)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('secondbuttonselected'))),
                class: _normalizeClass(["button", `is-${__props.secondButtonSeverity}` + (_unref(displayVertically) ? ' button-vertical' : '')])
              }, _toDisplayString(__props.secondButtonText), 3))
            : _createCommentVNode("", true),
          (__props.thirdButtonText)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('thirdbuttonselected'))),
                class: _normalizeClass(["button", `is-${__props.thirdButtonSeverity}` + (_unref(displayVertically) ? ' button-vertical' : '')])
              }, _toDisplayString(__props.thirdButtonText), 3))
            : _createCommentVNode("", true)
        ], 2)
      ], 2)
    ])
  ], 2))
}
}

})